// @ts-nocheck
import { ReplayHighlight } from "src/features/events/model/replay-highlight";
import lastKeyInMap from "src/shared/util/last-key-in-map";

let errorShown = false;

export default function getReplayHighlightRanges(
  _replayHighlightedProduct: ReplayHighlight[],
  duration?: number
) {
  const replayHighlightedProduct = autoStopUnstoppedStartEvents(
    _replayHighlightedProduct
  );

  const highlightRanges = new Map<
    string,
    { start: number; end: number; highlight: HighlightedProduct }
  >();

  replayHighlightedProduct.forEach((event, index) => {
    const validHighlights = duration
      ? replayHighlightedProduct.filter((event) => event.timestamp < duration)
      : [];
    const isLast = event.id === validHighlights[validHighlights.length - 1]?.id;

    if (duration && event.timestamp > duration) {
      !errorShown &&
        console.error(
          "A highligth timestamp is greater than video duration! Highlight data received from back-end should not include events outside of m3u8 video duration range. "
        );
      errorShown = true;
    } else {
      if (event.type === "highlight_start") {
        highlightRanges.set(index, {
          highlightId: event.id,
          start: event.timestamp,
          end: isLast ? event.timestamp : null,
          highlight: event.object,
        });
      }
      if (event.type === "highlight_stop") {
        const lastKey = lastKeyInMap(highlightRanges);
        const prevValue = highlightRanges.get(lastKey);
        highlightRanges.set(lastKey, {
          highlight: event.object,
          ...prevValue,
          end: event.timestamp,
          highlightId: event.id,
        });
      }
    }
  });

  return highlightRanges;
}

// If a highlight_start events are logged one after another,
// the missing highlight_stop event is added automatically.
function autoStopUnstoppedStartEvents(
  replayHighlightedProduct: ReplayHighlight[]
) {
  const autoStoppedReplayHighlightedProduct = [];
  replayHighlightedProduct.forEach((event, index) => {
    const nextEvent = replayHighlightedProduct[index + 1];
    if (
      event.type === "highlight_start" &&
      nextEvent &&
      nextEvent.type === "highlight_start"
    ) {
      autoStoppedReplayHighlightedProduct.push(event);
      const stopEvent = {
        ...event,
        type: "highlight_stop",
        timestamp: nextEvent.timestamp - 1,
      };
      autoStoppedReplayHighlightedProduct.push(stopEvent);
    } else {
      autoStoppedReplayHighlightedProduct.push(event);
    }

    return event;
  });

  return autoStoppedReplayHighlightedProduct;
}
